import { render, staticRenderFns } from "./PropPostsTotal.vue?vue&type=template&id=10ec279e&"
import script from "./PropPostsTotal.vue?vue&type=script&lang=js&"
export * from "./PropPostsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports